module.exports = __webpack_public_path__ + "img/logo.6dc8a9ef.png";